var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSimulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.961,20.036l-.889-3.654-.973.236.803,3.297-3.902-2.374v-7.105l-6.5-3.715V2.318l2.45,2.45.707-.707-2.659-2.66c-.537-.534-1.407-.533-1.944,0l-2.659,2.659.707.707,2.398-2.398v4.349l-6.5,3.715v7.105l-3.902,2.374.803-3.297-.973-.236L.04,20.036c-.087.356-.03.726.16,1.039.191.314.492.535.85.621l3.654.89.236-.971-3.368-.82,3.653-2.223,6.774,3.872,6.774-3.872,3.653,2.223-3.368.82.236.971,3.654-.89c.357-.086.658-.307.85-.621.19-.313.247-.683.161-1.039Zm-11.961-6.347l-5.339-3.052,5.339-3.051,5.339,3.051-5.339,3.052Zm.5.867l5.5-3.143v6.45l-5.5,3.143v-6.45Zm-6.5-3.143l5.5,3.143v6.45l-5.5-3.143v-6.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSimulation);
export default __webpack_public_path__ + "static/media/icon-simulation.1029c965df464350b88add5d0618b5d0.svg";
export { ForwardRef as ReactComponent };